const DISMISS_KEY = 'frontend-v2-banner-dismiss:v1';
const EVT = 'frontend-v2-banner:change';

export function isV2BannerDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function setV2BannerDismissed(dismissed: boolean): void {
  try {
    if (dismissed) localStorage.setItem(DISMISS_KEY, '1');
    else localStorage.removeItem(DISMISS_KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(EVT));
}

export function subscribeV2BannerDismiss(cb: () => void): () => void {
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
}
